
      <button class="sideBarContainerToggle btnPlain" (click)="toggleSideBarMenu()"><svg-icon name="menu"></svg-icon></button>
      <div class="sidebarContainer" [ngClass]="{loading:isLoading, collapsed: isCollapsed, hidden: isHidden, showMenu: isMenuVisible}" detectBrowser>
          <button class="sideBarToggleBtn" (click)="toggleSideBarState()"><svg-icon name="arrow"></svg-icon></button>
          <div class="sideBarButtons">
             <ng-content></ng-content>
          </div>
      </div>
    